import type { BlockHintStyle } from '@gitbook/doc-core';
import { PaletteCommandType } from '@gitbook/react-uikit';
import { useEditor } from '@gitbook/slate-react';

import { useBlockPaletteFactory } from '../common';
import { HINT_STYLES } from './constants';

/**
 * Hook to use a commands palette definition to edit a hint block.
 */
export function useHintBlockPaletteFactory(input: { nodeKey: string }) {
    const { nodeKey } = input;
    const editor = useEditor();
    return useBlockPaletteFactory({
        nodeKey: input.nodeKey,
        aiCompletion: true,
        createExtraGroups: () => [
            {
                key: 'levels',
                commands: () => {
                    const block = editor.value.document.assertBlock(nodeKey);
                    const currentStyle = block.data.get('style');
                    const styles: BlockHintStyle[] = ['info', 'warning', 'danger', 'success'];

                    return styles.map((style) => {
                        return {
                            key: style,
                            type: PaletteCommandType.RADIO,
                            selected: currentStyle === style,
                            title: HINT_STYLES[style].title,
                            icon: HINT_STYLES[style].icon,
                            trigger: () => {
                                editor.change((change) => {
                                    change.setNodeByKey(block.key, {
                                        data: {
                                            style,
                                        },
                                    });
                                });
                            },
                        };
                    });
                },
            },
        ],
    });
}
